import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../../../utils";
import { PricebookPrice } from "../../../../utils/pricebookPrice";
import { formatDiscountPercent } from "../constants";
import {
  PeriodForm,
  PeriodLine,
  computePeriodPrice,
} from "./periodModel";

const NO_PRICE_FORM = { unitPrice: "", discountPercent: "" };

interface PeriodPricePreviewProps {
  form: Pick<PeriodForm, "unitPrice" | "discountPercent">;
  /** Undefined until a product is picked. */
  line: PeriodLine | undefined;
  bookDiscountPercent: number;
}

/** What the line sells at now (ราคาหลัก) next to what it would sell at inside the period. */
export default function PeriodPricePreview({
  form,
  line,
  bookDiscountPercent,
}: PeriodPricePreviewProps) {
  // With no own price the period would sell at the line's own price, so that IS the base price.
  const basePrice = computePeriodPrice(NO_PRICE_FORM, line, bookDiscountPercent);
  const periodPrice = computePeriodPrice(form, line, bookDiscountPercent);

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 2,
        bgcolor: (theme) => theme.palette.background.default,
      }}
    >
      <Stack gap={0.5}>
        <PriceLine label="ราคาหลัก" price={basePrice} />
        <PriceLine label="ราคาในช่วง" price={periodPrice} emphasized />
      </Stack>
    </Box>
  );
}

interface PriceLineProps {
  label: string;
  price: PricebookPrice | null;
  emphasized?: boolean;
}

function PriceLine({ label, price, emphasized = false }: PriceLineProps) {
  const text = price
    ? `รวม VAT ${formatNumber(price.priceInclVat)} · ก่อน VAT ${formatNumber(
        price.priceExVat,
      )} (ส่วนลด ${formatDiscountPercent(price.discountPercent)})`
    : "-";
  return (
    <Typography
      variant="body2"
      fontWeight={emphasized ? 700 : 400}
      color={emphasized ? "text.primary" : "text.secondary"}
    >
      {label}: {text}
    </Typography>
  );
}
